export class BarChartLabel {
    name?: string = '';
    color?: string ='';
}